export const MutationTypes = {
	CHANNEL_REPORT_OPTIONS: 'CHANNEL_REPORT_OPTIONS',
	CHANNEL_REPORT: 'CHANNEL_REPORT',
	CHANNEL_REPORT_PERIOD: 'CHANNEL_REPORT_PERIOD',
	FEATURES: 'FEATURES',
	GENERAL_ERRORS: 'GENERAL_ERRORS'
};
